import React from "react";
import type { NavLinkProps as NavLinkPropsPrimitive } from "react-router-dom";
import { NavLink as NavLinkPrimitive } from "react-router-dom";
import "./NavLink.scss";

export type NavLinkProps = NavLinkPropsPrimitive;

const NavLink = ({ className, ...rest }: NavLinkProps) => {
  return <NavLinkPrimitive className={`navlink ${className}`} {...rest} />;
};

NavLink.displayName = "NavLink";

export default NavLink;
